import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Grid,
  GridItem,
  Link,
  Spacer,
} from "@chakra-ui/react";
import { LinkContext } from "../../LinkContext";

interface Olymp {
  id: number;
  name: string;
}

const Olympiads = ({ olympList, color }: { olympList: Olymp[], color: string }) => {
  const [sliceEnd, setSliceEnd] = useState(0);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 1200) {
      setSliceEnd(Math.min(7, olympList.length));
    } else if (window.innerWidth > 480) {
      setSliceEnd(Math.min(5, olympList.length));
    } else {
      setSliceEnd(Math.min(4, olympList.length));
    }
  }, []);

  return (
    <Box>
      <Text as="b" fontSize="26px">
        Участие в этих олимпиадах поможет поступить без вступительных испытаний
      </Text>
      <Grid
        mt="20px"
        gap="20px"
        templateColumns={{
          base: "1fr", 
          md: "repeat(2, 1fr)", 
          xl: "repeat(4, 1fr)"
        }}
        templateRows={["repeat(5, 1fr)", "repeat(3, 1fr)", "repeat(2, 1fr)"]}
      >
        {olympList.slice(0, sliceEnd).map((olymp: Olymp, i: number) => (
          <LinkContext.Consumer>
            {(APP_LINK) => (
              <GridItem p="20px" border={`1px solid ${color}`}>
                <Grid h="100%" gap="20px" templateRows="1fr 24px">
                  <GridItem>
                    <Box>
                      <Text>{olymp.name}</Text>
                    </Box>
                  </GridItem>
                  <GridItem>
                    <Box>
                      <Link
                        href={`${APP_LINK}/olympiad-page?olympId=${olymp.id}`}
                        target="_blank"
                      >
                        <Text color="gray.400">Подробнее</Text>
                      </Link>
                    </Box>
                  </GridItem>
                </Grid>
              </GridItem>
            )}
          </LinkContext.Consumer>
        ))}
        <GridItem p="20px" color="white" bg={color}>
          <Grid h="100%" gap="20px" templateRows="1fr 24px">
            <GridItem>
              <Box>
                <Flex>
                  <Box>
                    <Text>Показано</Text>
                  </Box>
                  <Spacer />
                  <Box mt="10px">
                    <Text fontSize="41px" as="b">
                      {sliceEnd} из {olympList.length}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </GridItem>
            <GridItem>
              <Box
                cursor="pointer"
                w="fit-content"
                onClick={() => {
                  setShowAll(!showAll);
                  setSliceEnd(showAll ? 7 : olympList.length);
                }}
              >
                {showAll ? "Скрыть" : "Показать все"}
              </Box>
            </GridItem>
          </Grid>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default Olympiads;
